import { render } from "./Email.vue?vue&type=template&id=bccdae3c&scoped=true&ts=true"
import script from "./Email.vue?vue&type=script&lang=ts"
export * from "./Email.vue?vue&type=script&lang=ts"

import "./Email.vue?vue&type=style&index=0&id=bccdae3c&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bccdae3c"]])

export default __exports__